import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Accordion, Button } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import imageUrl from '../../assets/images/user.png';
import Loader from "../../Components/Loader";
import apiClient from "../../AppClient";

function StaffView() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [userDetails, setUserDetails] = useState({});
    const [allPermissions, setAllPermissions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        // Fetch all permissions
        apiClient.get('/staff/permissions/')
            .then(response => {
                setAllPermissions(response.data);
            })
            .catch(error => console.log(error));

        // Fetch user data if id exists
        if (id) {
            setLoading(true);
            apiClient.get(`/staff/${id}/`)
                .then(response => {
                    setUserDetails(response.data);
                    setLoading(false);
                })
                .catch(error => {
                    setError(error.response.data.detail);
                    setLoading(false);
                });
        }
    }, [id]);

    if (loading) {
        return <Loader size={50} />;
    }

    if (error) {
        return <div className="text-danger mt-2">{error}</div>;
    }

    return (
        <Container>
            <div className='w-100 d-flex justify-content-between'>
                <Link to='/staff/' className='btn btn-outline-secondary my-2'>رجوع</Link>
            </div>
            <h3>عرض المستخدم</h3>

            <Row className="d-none justify-content-md-center text-center">
                <Col md={10}>
                    <Image
                        src={
                            userDetails.image
                                ? `${process.env.REACT_APP_API_URL}${userDetails.image}`
                                : imageUrl
                        }
                        roundedCircle
                        width={150}
                        height={150}
                    />
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <div className="mb-3">
                        <label><strong>الاسم الاول:</strong></label>
                        <div>{userDetails.first_name}</div>
                    </div>
                </Col>
                <Col md={6}>
                    <div className="mb-3">
                        <label><strong>الاسم الاخير:</strong></label>
                        <div>{userDetails.last_name}</div>
                    </div>
                </Col>
            </Row>

            <div className="mb-3">
                <label><strong>اسم المستخدم:</strong></label>
                <div>{userDetails.username}</div>
            </div>

            <div className="mb-3">
                <label><strong>البريد الاليكتروني:</strong></label>
                <div>{userDetails.email}</div>
            </div>

            <div className="mb-3">
                <label><strong>الهاتف:</strong></label>
                <div>{userDetails.phone}</div>
            </div>

            <div className="mb-3">
                <label><strong>الحالة:</strong></label>
                <div>{userDetails.is_active ? "نشط" : "غير نشط"}</div>
            </div>

            <Accordion defaultActiveKey="0" className="mt-4 w-75">
                <Accordion.Item eventKey="0">
                    <Accordion.Header><strong>الصلاحيات</strong></Accordion.Header>
                    <Accordion.Body>
                        <Row>
                            {allPermissions.map((permission) => (
                                <Col key={permission.id} md={6}>
                                    <div>
                                        {permission.name}: {userDetails.permissions?.some((p) => p.id === permission.id) ? "✔️" : "❌"}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Button variant="danger" className="my-3" onClick={() => navigate('/staff/')}>رجوع</Button>
        </Container>
    );
}

export default StaffView;